import { FormGroup } from '@angular/forms';

// custom validator to check that two fields match
export function ValidatePropertyResidentType(controlName: string) {
    return (formGroup: FormGroup) => {

        const control = formGroup.controls[controlName];

        if (control.errors && !control.errors.invalid) {
            // return if another validator has already found an error on the control
            return;
        }

        if (control.value !== 'owner' && control.value !== 'renter')
            control.setErrors({ invalid: true });
        else
            control.setErrors(null);
    }
}
